import {
	applyMiddleware, compose, configureStore
}from "@reduxjs/toolkit"
import {
	routerMiddleware
}from "react-router-redux"
import thunk from "redux-thunk"
import history from "../helpers/history"
import errorMiddleware from "./middlewares/errorMiddleware"

// import globalMiddleware from "./middlewares/globalMiddleware"
import rootReducer from "./reducers"

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && process.env.NODE_ENV === 'development'
	? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
	: compose

const enhancer = composeEnhancers(applyMiddleware(thunk, routerMiddleware(history), errorMiddleware))

const inititalState = {}
export const store = configureStore({
	reducer        : rootReducer,
	preloadedState : inititalState,
	middleware     : [
		thunk,
		routerMiddleware(history),
		errorMiddleware
	]
})